import type {
  MentionNotification,
  ReactionNotification,
  ReplyNotification,
} from 'types/notification'

import { getDiscussionTargetProps } from 'utils/discussion-mixpanel'

export type DiscussionMixpanelType = 'mention' | 'reaction' | 'reply'

type DiscussionNotification =
  | MentionNotification
  | ReactionNotification
  | ReplyNotification

const DISCUSSION_NOTIFICATION_EVENT_TYPE: Record<
  DiscussionNotification['type'],
  DiscussionMixpanelType
> = {
  discussions_receive_mention: 'mention',
  discussions_receive_reaction: 'reaction',
  discussions_receive_reply: 'reply',
}

export function getDiscussionMixpanelProperties(
  notification: DiscussionNotification,
): Record<string, string | number> {
  return {
    ...getDiscussionTargetProps({
      target_type: 'track',
      target_object_id: notification.track_id,
    }),
    type: DISCUSSION_NOTIFICATION_EVENT_TYPE[notification.type],
    visibility: notification.visibility ?? 'internal',
    discussion_id: notification.discussion_id,
    ...(notification.type === 'discussions_receive_reaction'
      ? { reaction_type: notification.reaction_type }
      : {}),
  }
}
